import { useState, useEffect } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { storeCategoryPath } from 'lib/urls'
import CategoryHero from './category-hero'
import CategoryGrid from '../CategoryGrid'
import ShopByGuides from '../shop-by-guides'
import FrequentlyAskedQuestions from '../FrequentlyAskedQuestions/FrequentlyAskedQuestions'
import { CatalogCategoryShape } from '../../lib/prop-types'

const ParentCategoryPage = ({
  activeCategory,
  maybeFetchChildCategoryProducts,
}) => {
  const [isFetching, setIsFetching] = useState(false)
  const {
    teaser,
    teaserLinkText,
    teaserLinkUrl,
    title,
    children,
    guides,
    slugSet,
    frequentlyAskedQuestions,
  } = activeCategory

  const teaserImageUrl = teaser?.imageUrl
  const teaserText = teaser?.text

  useEffect(() => {
    const fetchChildCategoryProducts = async () => {
      if (!isFetching) {
        setIsFetching(true)
        await maybeFetchChildCategoryProducts()
        setIsFetching(false)
      }
    }

    fetchChildCategoryProducts()
  }, [maybeFetchChildCategoryProducts])

  return (
    <div>
      <CategoryHero
        imageUrl={teaserImageUrl}
        path={storeCategoryPath(activeCategory.urlSlug)}
        teaser={teaserText}
        teaserLinkText={teaserLinkText}
        teaserLinkUrl={teaserLinkUrl}
        title={title}
      />
      <hr
        className={classNames('mts mbm hidden-xs hidden-sm', {
          hidden: !!teaserImageUrl,
        })}
      />
      {teaserText && !teaserImageUrl && (
        <div className="hidden-xs h6">{teaserText}</div>
      )}
      <CategoryGrid categories={children} parentSlugSet={slugSet} />
      <ShopByGuides guides={guides} />
      {frequentlyAskedQuestions?.length > 0 && (
        <div className="mtxl">
          <FrequentlyAskedQuestions
            headerVariant="secondary"
            questions={frequentlyAskedQuestions}
          />
        </div>
      )}
    </div>
  )
}

ParentCategoryPage.propTypes = {
  activeCategory: PropTypes.shape(CatalogCategoryShape).isRequired,
  maybeFetchChildCategoryProducts: PropTypes.func.isRequired,
}

export default ParentCategoryPage
